import React, { useEffect, useMemo, useState } from "react";
import cn from "classnames";

import { getAnniversaries, notifyTodayBirthdays, toBeautifullText } from "./utils";
import { Plate } from "../helpfull/Plate";
import { HeaderTitle } from "../helpfull/HeaderTitle";
import { TinyButton } from "../helpfull/TinyButton";

import BEM from "./Anniversaries.module.scss";

import headingicon from "./assets/headingicon.svg";

export const Anniversaries = () => {
  const [anniversaries, setAnniversaries] = useState({
    thisMonth: [],
    farFuture: [],
    thisDays: [],
  });

  useEffect(() => {
    setTimeout(() => {
      const anniversaries = getAnniversaries()
      setAnniversaries(anniversaries);
      notifyTodayBirthdays(anniversaries);
    }, 0);
  }, []);

  const [isUnfolded, setIsUnfolded] = useState(false);
  const [presetWindowOpened, setPresetWindowOpened] = useState(false);
  const [textAriaValue, setTextAriaValue] = useState("");

  useEffect(() => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, []);

  return (
    <Plate
      customClassName={cn({
        [BEM.plateHiglighted]: !!anniversaries.thisDays.length,
      })}
    >
      <div className={BEM.block}>
        <header className={BEM.header}>
          <HeaderTitle title="Свята і річниці" icon={headingicon} />
          <button
            onClick={() => setPresetWindowOpened(!presetWindowOpened)}
            className={BEM.headerButton}
          >
            +
          </button>
        </header>

        {presetWindowOpened && (
          <div>
            <textarea
              value={textAriaValue}
              onChange={(event) => setTextAriaValue(event.target.value)}
              className={BEM.textAria}
              placeholder="paste your config here"
            ></textarea>
            <button
              style={{ cursor: "pointer" }}
              onClick={() => {
                localStorage.setItem("config/anniversaries", textAriaValue);
                location.reload();
              }}
            >
              UPDATE
            </button>
          </div>
        )}

        <main className={BEM.content}>
          <div className={BEM.section}>
            <h4 className={BEM.sectionTitle}>{"Цього місяця"}</h4>
            {anniversaries.thisMonth.length ? (
              anniversaries.thisMonth.map((anni) => (
                <p key={anni.title + anni.date} className={BEM.anniversary}>
                  <span className={BEM.date}>
                    {toBeautifullText(anni.date)}
                    {" залишилось ще "}
                    <strong>{anni.left}</strong>
                    {" днів"}
                  </span>
                  <span className={BEM.title}>{anni.title}</span>
                </p>
              ))
            ) : (
              <p className={BEM.nothing}>Нічого</p>
            )}
          </div>

          {isUnfolded && (
            <div className={BEM.section}>
              <h4 className={BEM.sectionTitle}>{"Всі інші"}</h4>
              {anniversaries.farFuture.length ? (
                anniversaries.farFuture.map((anni) => (
                  <p key={anni.title + anni.date} className={BEM.anniversary}>
                    <span className={BEM.date}>
                      {toBeautifullText(anni.date)}
                      {" залишилось ще "}
                      <strong>{anni.left}</strong>
                      {" днів"}
                    </span>
                    <span className={BEM.title}>{anni.title}</span>
                  </p>
                ))
              ) : (
                <p className={BEM.nothing}>Нічого</p>
              )}
            </div>
          )}

          <TinyButton
            className={BEM.tinyBtn}
            onClick={() => setIsUnfolded(!isUnfolded)}
          >
            {isUnfolded ? "Згорнути" : "Показати всі інші"}
          </TinyButton>
        </main>
      </div>
    </Plate>
  );
};
